import { render, staticRenderFns } from "./OrderReviewPayment.vue?vue&type=template&id=6167786a&scoped=true"
import script from "./OrderReviewPayment.vue?vue&type=script&lang=js"
export * from "./OrderReviewPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6167786a",
  null
  
)

export default component.exports